import { tap } from 'rxjs/operators';
import { HisValueGroup } from '../../model/his-value-group';
import { Component, Input, Output, EventEmitter, AfterViewInit, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicContainerInnerComponent } from './dynamic-container-inner.component';

@Component( {
    selector: 'his-dynamic-container',
    templateUrl: './dynamic-container.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDynamicContainerComponent implements OnInit {

    @Input() dynamicFieldConfig: HisDynamicFieldConfig;
    @Output() readyToUse: EventEmitter<string> = new EventEmitter();

    valueGroup: HisValueGroup;
    form: UntypedFormGroup = new UntypedFormGroup( {} );

    ngOnInit() {
        this.valueGroup = new HisValueGroup( this.dynamicFieldConfig.children.length );
        this.valueGroup.valueGroupReady.pipe(
            tap( _ => this.readyToUse.emit( 'HisDynamicContainerComponent is ready' ) )
        ).subscribe();
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        this.valueGroup.updateConfiguration( entireFormConfig );
    }

    /**
     * @deprecated
     * Will be deleted shortly. Use getJson instead.
     */
    getStringRepresentation(): any {
        return this.valueGroup.getJson();
    }

    getJson( ignoreEmptyValues: boolean = true ): any {
        return this.valueGroup.getJson( ignoreEmptyValues );
    }

    resetDynamicForm() {
        this.valueGroup.resetDynamicForm();
    }

    dropDynamicForms() {
        this.valueGroup.dropDynamicFields();
    }
}
